<body>
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <span id="headerText">Home Gardening</span>
            </div>
        </div>
        <hr><br>
        <div class="row">
            <div class="col-sm-6">
                <h2>Tips & Review: Mga Halaman na Pwedeng Ilagay sa Loob ng Bahay.</h2>
               <span>
                Sharing tips what plants are best for your home, How to care and where to place them! Watch this video as we review these 10 indoor plants: Spider Plant, Cactus, Fern, Aloe Vera, Areca Palm, Snake Plant, Pothos, Cigar Plant, Succulent and ZZ Plant.
                <br><br>
                Video overview :
                <br>
                <div class="display:flex">
                    <mat-icon class="c-default" aria-hidden="false" aria-label="Example home icon">done</mat-icon> 
                    <span>How to care Indoor plants</span>
                </div>
                <div class="display:flex">
                    <mat-icon class="c-default" aria-hidden="false" aria-label="Example home icon">done</mat-icon> 
                    <span>Watering and sunlight for the plants</span>
                </div>
                <div class="display:flex">
                    <mat-icon class="c-default" aria-hidden="false" aria-label="Example home icon">done</mat-icon> 
                    <span>What kind of soil to use</span>
                </div>
                <div class="display:flex">
                    <mat-icon class="c-default" aria-hidden="false" aria-label="Example home icon">done</mat-icon> 
                    <span>Ideal place for plants</span>
                </div>
                <div class="display:flex">
                    <mat-icon class="c-default" aria-hidden="false" aria-label="Example home icon">done</mat-icon> 
                    <span>Trivia & Review</span>
                </div>
                <div class="display:flex">
                    <mat-icon class="c-default" aria-hidden="false" aria-label="Example home icon">done</mat-icon> 
                    <span>Helpful tips</span>
                </div>
                <br><br>
                Do you have any questions? or suggestions feel free to send us a message to our facebook page.
                <br>
                <hr>
                <img src="assets/social/fb.jpg" style="width:32px;height:32px"> <a href="https://www.facebook.com/plantplaceph" style="text-decoration:none"> Plant Place</a>
               </span>
            </div>
            <div class="col-sm-6">
                <iframe 
                width="560" 
                height="315" 
                src="https://www.youtube.com/embed/ipwkVSmEbKg" 
                frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowfullscreen>
            </iframe>
            </div>
        </div>
    </div>
</body>